import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    section: {
      display: "flex",
      flexDirection: "column",
      padding: theme.spacing(8, 12),
      borderBottom: `1px solid ${theme.gray200}`,
      boxShadow: `0px 1px 1px 0px ${theme.gray100}`,
      backgroundColor: `${theme.gray50}33`,
    },
    rulesSection: {
      padding: theme.spacing(12),
    },
    menuContainer: {
      backgroundColor: theme.gray50,
      borderRadius: "6px",
      border: `1px solid ${theme.gray200}`,
      paddingRight: theme.spacing(10),
    },
    sectionTitleWrapper: {
      display: "flex",
      gap: theme.spacing(8),
    },
    headerWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    error: {
      color: theme.red500,
      borderColor: theme.red500,
    },
  }),
);
